//Generated via script "generate-types.js"


export const skinCategories = ["accessories","body","clothes"] as const

export type SkinCategory = typeof skinCategories[number]

export type AnimationName = 'blink' | 'eye-squeeze' | 'gasp' | 'isIdle' | 'smile' | 'struggle1'

export const accessoriesTypes = ["blindfold","gag"] as const

export type Accessories = typeof accessoriesTypes[number]

export const blindfolds = ["blindfold1","blindfold2","blindfold3","blindfold4"] as const

export type Blindfold = typeof blindfolds[number]

export const gags = ["gag1","gag2","gag3","gag4","gag5","gag6","gag7","gag8","gag9","gag10"] as const

export type Gag = typeof gags[number]

export const bodyTypes = ["damsel"] as const

export type Body = typeof bodyTypes[number]

export const damsels = ["heather","liana","rachel","sally"] as const

export type Damsel = typeof damsels[number]

export const clothesTypes = ["bottom","bra","top","underwear"] as const

export type Clothes = typeof clothesTypes[number]

export const bottoms = ["pants1","pants2","pants3","shorts1","shorts2","shorts3","shorts4","skirt1","skirt2","skirt3","skirt4"] as const

export type Bottom = typeof bottoms[number]

export const bras = ["bra1","bra2","bra3","bra4","bra5","bra6","bra7","bra8","bra9","bra10","bra11","bra12","bra13","bra14","bra15","bra16","bra17","bra18","bra19","bra20","bra21"] as const

export type Bra = typeof bras[number]

export const tops = ["shirt1","shirt2","shirt3","shirt4","shirt5","shirt6","shirt7","shirt8","shirt9","shirt10","shirt11","shirt12","tanktop1","tanktop2","tanktop3","tanktop4"] as const

export type Top = typeof tops[number]

export const underwears = ["underwear1","underwear2","underwear3","underwear4","underwear5","underwear6","underwear7","underwear8","underwear9","underwear10","underwear11","underwear12","underwear13","underwear14","underwear15","underwear16","underwear17","underwear18","underwear19","underwear20","underwear21"] as const

export type Underwear = typeof underwears[number]

export type DamselConfig = {
  blindfold?: Blindfold
  gag?: Gag
  damsel: Damsel
  bottom?: Bottom
  bra?: Bra
  top?: Top
  underwear?: Underwear
}

export type DamselConfigInput = Partial<DamselConfig>

export type Asset = 'damsel' | 'tools'

